import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import { UserModel } from '../model/index';
@Injectable()
export class UserService {
    private headers = new Headers({
       'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'

        //'Content-Type': 'application/x-www-form-urlencoded charset=UTF-8', 'Accept': 'q=0.8;application/json;q=0.9'
    });
    private userUrl = 'api/user';  // URL to web api

    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    getUserList(query: any): Promise<UserModel[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.userUrl}/getUserList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getDashboardUserList(): Promise<any> {
        let params: URLSearchParams = new URLSearchParams();
        params.set('orderColumn', 'username');
        params.set('orderDir', 'asc');
        let options = new RequestOptions({ headers: this.headers, search: params });
        return this.http.get(`${this.userUrl}/getDashboardUserList`, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

   //  deleteBranch(company_id: any): Promise<UserModel> {
   //     const url = `${this.userUrl}/deleteBranch`;
   //     return this.http
   //         .post(url, $.param({ company_id: company_id }), { headers: this.headers })
   //         .toPromise()
   //         .then(res => res.json() as UserModel)
   //         .catch(this.handleError);
   // }

   addUpdateUser(userData: any): Promise<UserModel> {
       const url = `${this.userUrl}/addUpdateUser`;

       return this.http
           .post(url, $.param(userData), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as UserModel)
           .catch(this.handleError);
   }

   getDoctorUserList(query: any): Promise<UserModel[]> {
       let params: URLSearchParams = new URLSearchParams();
       for (let key in query) {
           params.set(key.toString(), query[key]);
       }

       let options = new RequestOptions({
           headers: this.headers,
           search: params
       });

       const url = `${this.userUrl}/getDoctorUserList`;
       return this.http.get(url, options)
           .toPromise()
           .then(this.extractData)
           .catch(this.handleError);
   }

   addUpdateDoctorUser(userData: any): Promise<UserModel> {
       const url = `${this.userUrl}/addUpdateDoctorUser`;

       return this.http
           .post(url, $.param(userData), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as UserModel)
           .catch(this.handleError);
   }

   updateDoctorUser(userData: any): Promise<UserModel> {
       const url = `${this.userUrl}/updateDoctorUser`;

       return this.http
           .post(url, $.param(userData), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as UserModel)
           .catch(this.handleError);
   }

   deleteDoctorUser(userid: any): Promise<UserModel> {
       const url = `${this.userUrl}/deleteDoctorUser`;

       return this.http
           .post(url, $.param({ userid: userid }), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as UserModel)
           .catch(this.handleError);
   }

   uploadDoctorUsers(uploadData: any): Promise<UserModel> {
       const url = `${this.userUrl}/uploadDoctorUsers`;

       return this.http
           .post(url, $.param(uploadData), { headers: this.headers })
           .toPromise()
           .then(res => res.json() as UserModel)
           .catch(this.handleError);
   }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/services/user.service.ts